class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener(
      'keyup',
      (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
    );
    this.summaryToggle.addEventListener(
      'click',
      this.onSummaryClick.bind(this)
    );
    this.detailsContainer.addEventListener('click', (event) => {
      if (event.target.closest('.modal__close-button, .search-modal__close-button')) {
        this.close();
      }
    });

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    this.onBodyClickEvent =
      this.onBodyClickEvent || this.onBodyClick.bind(this);
    const details = (event && event.target && event.target.closest('details')) || this.detailsContainer;
    details.setAttribute('open', true);
    this.detailsContainer.dispatchEvent(new Event('toggle'));
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');

    const isMobile = window.innerWidth < 768;
    const focusTarget = isMobile
      ? (this.detailsContainer.querySelector('[tabindex="-1"]') || this.detailsContainer)
      : this.detailsContainer.querySelector('input:not([type="hidden"])');

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      focusTarget
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    this.detailsContainer.dispatchEvent(new Event('toggle'));
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('details-modal', DetailsModal);
